<template>
  <div class="pages-body notfound-page flex flex-column">
    <div class="topbar p-3 flex justify-content-between flex-row align-items-center">
      <router-link class="topbar-left ml-3 flex" to="/">
        <div class="logo">
          <img src="/layout/images/sa_panel_text.png" alt=""/>
        </div>
      </router-link>
    </div>

    <div class="align-self-center mt-auto mb-auto">
      <div class="pages-panel card flex flex-column">
        <div class="pages-header px-3 py-1">
          <h2>{{ $t('not_found_page.title') }}</h2>
        </div>
        <div class="card mt-3 px-6">
          <img src="/layout/images/pages/404.png" alt=""/>
        </div>
        <div class="pages-detail pb-6">{{ $t('not_found_page.description') }}</div>
        <router-link to="/">
          <Button type="button" :label="$t('not_found_page.button')" class="p-button-text"></Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
</script>

<style scoped>

</style>
